export const useSxStyles = () => {
  return {
    root: {
      display: 'grid',
      gridTemplateAreas: 'switch fields delete',
      gridTemplateColumns: '60px 1fr auto',
      alignItems: 'center',
      width: '100%',
    },
    iconButton: {},
  };
};
